import { getSessionPlayer } from '../../commons/getSessionPlayerRequire';
import type { handleVisualTestingResult as HandleVisualTestingResultFn } from 'clickim/src/background/eyesUtils';

type HandleVisualTestingResult = typeof HandleVisualTestingResultFn;

let cachedHandler: HandleVisualTestingResult | undefined;

export const getVisualTestingResultHandler = (): HandleVisualTestingResult => {
    if (!cachedHandler) {
        const sessionPlayer = getSessionPlayer();
        cachedHandler = sessionPlayer.handleVisualTestingResult
            ?? sessionPlayer.EyeSdkBuilder.handleVisualTestingResult
            ?? sessionPlayer.EyeSdkBuilder.handleApplitoolsSdkResult;
    }
    return cachedHandler;
};
